import { setSessionStorage } from "../../service/SessionStorageService";
import { Constants } from "../../utils/Constants";

export const UPDATE_LOGGED_IN_USER = "UPDATE_LOGGED_IN_USER";
export const SET_USER_NAME = "SET_USER_NAME";
export const SET_ROLES = "UDATE_ROLES";

export function loggedInStateInit() {
	return { loggedIn: JSON.parse(sessionStorage.getItem(Constants.loggedIn)) ?? false };
}
export function loggedInNameInit() {
	return JSON.parse(sessionStorage.getItem(Constants.nameState)) ?? { displayName: null, family_name: null, given_name: null }
}
export function loggedInUserRolesInit() {
	return { accessrole: JSON.parse(sessionStorage.getItem(Constants.rolesState)) ?? [] }
}

export const loggedInUserReducer = (state, { type, payload }) => {
	switch (type) {
		case UPDATE_LOGGED_IN_USER:
			setSessionStorage(Constants.loggedIn, payload?.loggedIn);
			return { ...state, loggedIn: payload?.loggedIn };
		case SET_USER_NAME:
			const { displayName, family_name, given_name } = payload
			setSessionStorage(Constants.nameState, JSON.stringify({ displayName, family_name, given_name }));
			return { ...state, displayName, family_name, given_name };
		case SET_ROLES:
			setSessionStorage(Constants.rolesState, JSON.stringify([...payload?.roles]));
			return { ...state, accessrole: [...payload?.roles] };
		default:
			return state;
	}
};